import { Controller } from "@hotwired/stimulus"
import { t } from "../i18n.js"

export default class extends Controller {
  static targets = ["text"]
  static values = { total: Number, existing: Number }

  connect() {
    this.list = document.getElementById("documents_list") || document.getElementById("documents")
    this.expected = (this.existingValue || 0) + (this.totalValue || 0)
    this.pending = Math.max(this.expected - this.currentCount(), 0)

    if (this.pending <= 0) {
      this.element.closest('.import-banner')?.remove()
      return
    }

    this.updateText()
    this.beforeStreamHandler = this.beforeStream.bind(this)
    document.addEventListener("turbo:before-stream-render", this.beforeStreamHandler)
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.beforeStreamHandler)
  }

  currentCount() {
    return this.list ? this.list.querySelectorAll("tr").length : 0
  }

  beforeStream(event) {
    const stream = event.target
    const action = stream.getAttribute("action")
    const target = stream.getAttribute("target")

    const updatesPending = () => {
      this.pending = Math.max(this.pending - 1, 0)
      if (this.pending <= 0) {
        this.element.closest('.import-banner')?.remove()
      } else {
        this.updateText()
      }
    }

    if (action === "prepend" && (target === "documents" || target === "documents_list")) {
      if (stream.templateContent.querySelector('tr')) {
        updatesPending()
      }
    } else if (action === "replace" && target && (target.startsWith("document_") || target === "documents_list")) {
      if (stream.templateContent.querySelector('tr')) {
        updatesPending()
      }
    }
  }

  updateText() {
    if (this.hasTextTarget) {
      const key = this.pending === 1 ? 'importing_one' : 'importing_many'
      this.textTarget.textContent = t(key, `Importing %{count} document${this.pending === 1 ? '' : 's'}…`, { count: this.pending })
    }
  }

  close() {
    this.element.closest('.import-banner')?.remove()
  }
}
